import { Component, Input, computed } from '@angular/core';

type IconSize = 'sm' | 'md' | 'lg';

/**
 * Renders a single symbol character at a given size, used as a lightweight icon primitive.
 */
@Component({
  selector: 'es-icon',
  template: '<span [class]="classes()" [style.color]="color">{{ symbol }}</span>',
})
export class IconComponent {
  @Input({ required: true }) symbol!: string;
  @Input() size: IconSize = 'md';
  @Input() color?: string;

  classes = computed(() => {
    const sizes: Record<IconSize, string> = {
      sm: 'text-xs',
      md: 'text-sm',
      lg: 'text-lg',
    };
    return `inline-block leading-none ${sizes[this.size]}`;
  });
}
